$(document).ready(function() {
  var typingTimer;
  var doneTypingInterval = 100;

  $('header input[name="q"]').on('input', function () {
    clearTimeout(typingTimer);
  });

  $('header input[name="q"]').on('search', function () {
    var searchText = $('header input[name="q"]').val();
    if(searchText == '') {
      $('#predictive-results__wrapper').removeClass('active');
      $('.overlay').removeClass('active');
      $('body').removeClass('overflow-none');
      return false;
    }
  });

  $('header input[name="q"]').on('keyup', function () {
    typingTimer = setTimeout(function() {
      var searchText = $('header input[name="q"]').val();
      if(searchText == '') {
        $('#predictive-results__wrapper').removeClass('active');
        $('.overlay').removeClass('active');
        $('body').removeClass('overflow-none');
        return false;
      }
      $.ajax({
        url: `/search?q=${searchText}&view=ajax&type=product,page`,
        method: 'POST',
        success: function (data) {
          $('body').addClass('overflow-none');
          $('#predictive-results__wrapper').html(data);
          $('#predictive-results__wrapper').addClass('active');
          $('.overlay').addClass('active');
        }
      });
    }, doneTypingInterval);
  });

  $('.overlay').click(function(params) {
    $('#predictive-results__wrapper').removeClass('active');
    $('.overlay').removeClass('active');
    $('body').removeClass('overflow-none');
    $('input[name="q"]').val('');
  })
});